// Cache names shared between the service worker's runtime routes and the
// in-page offline sync (offlineSync.js writes into these same caches).
export const API_CACHE = 'field-guide-api'
export const IMAGE_CACHE = 'field-guide-images'
export const TILE_CACHE = 'field-guide-tiles'
